module.exports = __webpack_public_path__ + "static/media/studio-etc11.bc6675fe.png";